var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "responsiveSection promoBanner__wrapper padding-top-20" },
    [
      _c("div", { staticClass: "responsiveSection__grid" }, [
        _c(
          "div",
          {
            staticClass: "promoBanner margin-vertical-50 margin-horizontal-20",
          },
          [
            _c("div", { staticClass: "flex pos-relative" }, [
              _c("div", { staticClass: "width70 flex__item--center" }, [
                _c("h2", { staticClass: "sectionRooftitle" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.bannerTitle) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "h3",
                  {
                    staticClass:
                      "responsiveText display-block margin-horizontal-auto h3 margin-bottom-0 text-color--white",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.bannerHeadline) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "text-color--white margin-top-20" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.bannerDescription) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { domProps: { innerHTML: _vm._s(_vm.bannerItems) } }),
                _vm._v(" "),
                _c("div", { staticClass: "margin-top-20" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button button--medium button--primary",
                      attrs: {
                        href: _vm.corporate ? _vm.caPath : _vm.paPath,
                        "data-gtm": `search__account--overview--${_vm.currentTab}`,
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.bannerButton) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "width30 margin-top-s-20 banner__image--hide flex__item--center",
                },
                [
                  _c("div", { staticClass: "contentCard__image" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.bannerSrc,
                        alt: "banner",
                        width: "355",
                        height: "253",
                      },
                    }),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }